import React, { useState, useRef, useEffect } from "react";
import CreateTodo from "./createTodo.js"; // importer CreateTodo
import { useEtatGlobal } from "../../../EtatGlobal.js";
import ModifRadiation from "./Update/ModifRadiation.js";
import {
  X,
  Building2,
  CheckSquare,
  Edit2,
  FileText,
  MessageSquare,
  History,
} from "lucide-react";
import { authFetch } from '../../../../HttpClient';

const Radiation = ({ item, setItem, onClose, fetchData, onItemUpdate }) => {
  const [status, setStatus] = useState(item?.status || "");
  const [showCreateTodo, setShowCreateTodo] = useState(false); // nouvel état

  const [commentaireInput, setCommentaireInput] = useState("");
  const [isSendingComment, setIsSendingComment] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false); // nouvel état
  const originalStatus = useRef(item?.status || "");

  const { utilisateur } = useEtatGlobal();

  useEffect(() => {
    originalStatus.current = item?.status || "";
    setStatus(item?.status || "");
  }, [item]);

  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    return new Date(dateStr).toLocaleDateString("fr-FR");
  };

  const handleStatusChange = async (newStatus) => {
    setStatus(newStatus);
    try {
      const res = await authFetch(`https://backend-myalfa.vercel.app/api/Radiation/${item.id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ status: newStatus }),
        }
      );

      if (!res.ok) throw new Error("Erreur lors de la mise à jour du statut");
    } catch (error) {
      console.error(error);
    }
    onItemUpdate?.(item.id, item.source, { status: newStatus });
  };

  const itemtype = "Radiation"; // Assurez-vous que l'item a un type

  if (!item) return null;

  const getStatusColor = (status) => {
    switch (status) {
      case "Terminé":
        return "#c8e6c9";
      case "Rédaction":
      case "Formalité":
      case "Supervision":
      case "En attente":
      case "Signature":
        return "#d0ebff";
      case "Abandonné":
      case "Bloqué":
        return "#fff9c4";
      default:
        return "transparent";
    }
  };

  const getTextColor = (status) => {
    switch (status) {
      case "Terminé":
        return "#2e7d32"; // vert foncé, bon contraste avec #c8e6c9
      case "Rédaction":
      case "Formalité":
      case "Supervision":
      case "En attente":
      case "Signature":
        return "#0d47a1"; // bleu foncé, contraste avec #d0ebff
      case "Abandonné":
      case "Bloqué":
        return "#f57f17"; // jaune/marron foncé, contraste avec #fff9c4
      default:
        return "#000000"; // noir par défaut
    }
  };

  // Si on est en mode création todo, afficher ce composant uniquement
  if (showCreateTodo) {
    return (
      <div className="overlayAC">
        <div
          className="inoverlayMS"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <button
            className="close-button"
            onClick={async (e) => {
              e.stopPropagation();
              onClose();
            }}
            style={{
              position: "absolute",
              top: "12px",
              right: "12px",
              background: "transparent",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
              zIndex: 10000,
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#555")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "#999")}
            aria-label="Fermer"
          >
            <button
              aria-label="Fermer"
              className="p-2 rounded-md text-gray-500 hover:text-gray-800 bg-gray-200 transition"
            >
              <X className="w-4 h-4" />
            </button>
          </button>

          <CreateTodo
            onBack={() => setShowCreateTodo(false)}
            item={item}
            itemtype={itemtype}
            fetchData={fetchData}
            onClose={onClose}
          />
        </div>
      </div>
    );
  }

  if (showUpdate) {
    return (
      <div className="overlayAC">
        <div
          className="inoverlayMS"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <button
            className="close-button"
            onClick={async (e) => {
              e.stopPropagation();
              onClose();
            }}
            style={{
              position: "absolute",
              top: "12px",
              right: "12px",
              background: "transparent",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
              zIndex: 10000,
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#555")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "#999")}
            aria-label="Fermer"
          >
            <button
              aria-label="Fermer"
              className="p-2 rounded-md text-gray-500 hover:text-gray-800 bg-gray-200 transition"
            >
              <X className="w-4 h-4" />
            </button>
          </button>

          <ModifRadiation
            onBack={() => setShowUpdate(false)}
            item={item}
            itemtype={itemtype}
            onClose={onClose}
            fetchData={fetchData}
          />
        </div>
      </div>
    );
  }

  const handleAddComment = async () => {
    if (!commentaireInput.trim()) return;

    setIsSendingComment(true);

    // Créer un objet commentaire temporaire pour l'affichage instantané
    const nouveauCommentaire = {
      nomComplet: `${utilisateur.lastName} ${utilisateur.name}`,
      commentaire: commentaireInput,
      createdAt: new Date().toISOString(), // date temporaire
    };

    try {
      // Mettre à jour directement l'UI avant l'appel API
      setItem((prev) => ({
        ...prev,
        Commentaire: [...(prev.Commentaire || []), nouveauCommentaire],
      }));

      setCommentaireInput("");

      // Appel API en arrière-plan
      await authFetch("https://backend-myalfa.vercel.app/api/commentairesMission", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nomComplet: nouveauCommentaire.nomComplet,
          commentaire: nouveauCommentaire.commentaire,
          radiationId: item.id,
        }),
      });

      console.log("Commentaire ajouté avec succès");
      onItemUpdate?.(item.id, item.source, {
        Commentaire: [...(item.Commentaire || []), nouveauCommentaire],
      });
    } catch (error) {
      console.error("Erreur en ajoutant le commentaire :", error);
      setItem((prev) => ({
        ...prev,
        Commentaire: prev.Commentaire.filter((c) => c !== nouveauCommentaire),
      }));
    } finally {
      setIsSendingComment(false);
    }
  };

  return (
    <div className="overlayAC">
      <div
        className="inoverlayLead"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {/* <button
          className="close-button"
          onClick={async (e) => {
            e.stopPropagation();
            onClose();
          }}
          style={{
            position: "absolute",
            top: "40px",
            right: "420px",
            background: "transparent",
            border: "none",
            fontSize: "28px",
            fontWeight: "bold",
            color: "#999",
            cursor: "pointer",
            transition: "color 0.3s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#555")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#999")}
          aria-label="Fermer"
        >
          &times;
        </button> */}

        <div
          style={{
            backgroundColor: "#fff",
            borderRadius: "12px",
            width: "95%",
            margin: "0 auto",
          }}
        >
          <div className="bg-white border-b-4 border-[#8B1538] px-4 pb-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-6">
                {/* Logo Cabinet */}
                <img
                  src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/6969eee7337849d9e1d7fcb4/2957c578c_LogoAlfa-PNG-SansCartouche.png"
                  alt="Alfa"
                  className="h-16 object-contain"
                />
                <div className="h-12 w-px bg-slate-200" />
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <Building2 className="w-4 h-4 text-slate-500" />
                    <span className="text-xs font-medium text-slate-600 uppercase tracking-wide">
                      Radiation
                    </span>
                  </div>
                  <h1 className="text-2xl font-bold text-slate-900">
                    {item.client.nom}
                  </h1>
                </div>
              </div>

              <div className="flex items-center gap-2 justify-end">
                <button
                  aria-label="Fermer"
                  className="p-2 rounded-md text-gray-500 hover:text-gray-800 transition"
                  onClick={(e) => {
                    e.stopPropagation();
                    onClose();
                  }}
                >
                  <X className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2 justify-end mt-3">
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <label
                htmlFor="status-select"
                style={{
                  fontWeight: 600,
                  color: "#64748b",
                  whiteSpace: "nowrap",
                }}
              >
                Statut :
              </label>

              <select
                id="status-select"
                value={status}
                onChange={(e) => handleStatusChange(e.target.value)}
                style={{
                  height: "32px",
                  padding: "0 28px 0 10px",
                  borderRadius: "6px",
                  border: `1px solid ${getTextColor(status)}`,
                  fontSize: "12px",
                  fontWeight: 600,
                  color: getTextColor(status),
                  backgroundColor: getStatusColor(status),
                  cursor: "pointer",
                  outline: "none",
                  appearance: "none",
                  backgroundImage: `url("data:image/svg+xml;utf8,<svg fill='%2364748b' height='20' viewBox='0 0 24 24' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>")`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 8px center",
                }}
              >
                <option value="En attente">En attente</option>
                <option value="En attente informations / documents">
                  En attente informations / documents
                </option>
                <option value="En attente interne">En attente interne</option>
                <option value="Dépôt de capital en cours">
                  Dépôt de capital en cours
                </option>
                <option value="Rédaction">Rédaction</option>
                <option value="Supervision">Supervision</option>
                <option value="Signature">Signature</option>
                <option value="Signature en cours">Signature en cours</option>
                <option value="Formalité">Formalité</option>
                <option value="Formalité déposée">Formalité déposée</option>
                <option value="Formalité à régulariser">
                  Formalité à régulariser
                </option>
                <option value="Formalité rejetée">Formalité rejetée</option>
                <option value="Bloqué">Bloqué</option>
                <option value="Abandonné">Abandonné</option>
                <option value="Terminé">Terminé</option>
              </select>
            </div>
            <button
              onClick={() => setShowCreateTodo(true)}
              variant="outline"
              className="
                  inline-flex items-center
                  px-3 py-1.5 text-sm font-medium
                  border border-[#8B1538]
                  text-[#8B1538]
                  rounded-md
                  hover:bg-[#8B1538]
                  hover:text-white
                  transition-colors
                "
            >
              <CheckSquare className="w-4 h-4 mr-2" />
              ToDo
            </button>
            {(utilisateur.role === "ADMINISTRATEUR" ||
              utilisateur.role === "EXPERT_COMPTABLE") && (
              <button
                size="icon"
                variant="outline"
                onClick={() => setShowUpdate(true)}
                className="
                  inline-flex items-center justify-center
                  h-8 w-8
                  border border-gray-300
                  rounded-md
                  hover:bg-gray-100
                  transition-colors
                "
              >
                <Edit2 className="w-4 h-4" />
              </button>
            )}
          </div>

          <div className="bg-slate-50 rounded-lg border border-slate-200 p-6 mb-6 mt-4">
            <div className="flex items-center justify-between mb-4 ">
              {" "}
              <h3 className="text-base font-semibold text-slate-800 flex items-center gap-2 m-0">
                <FileText className="w-5 h-5 text-[#8B1538]" />
                Informations de la mission
              </h3>
            </div>
            <div className="flex items-center gap-6 mb-2">
              <p className="text-xs uppercase text-slate-500  m-0">
                Date d'effet
              </p>
              <p className=" text-xs font-medium m-0">
                {" "}
                {formatDate(item.datedEffet)}
              </p>
            </div>

            {["ADMINISTRATEUR", "EXPERT_COMPTABLE"].includes(
              utilisateur.role
            ) && (
              <div className="flex items-center gap-6 mb-2">
                <p className="text-xs uppercase text-slate-500">Coefficient</p>
                <p className=" text-xs font-medium">
                  {" "}
                  {item.coefficient || "-"}
                </p>
              </div>
            )}
            <div className="flex items-center gap-6 mb-2">
              <p className="text-xs uppercase text-slate-500">Note</p>
              <p className=" text-xs font-medium"> {item.commentaire}</p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-lg border border-slate-200 p-6 mt-6">
            {/* Header */}
            <h3 className="text-base font-semibold text-slate-800 mb-4 flex items-center gap-2">
              <MessageSquare className="w-5 h-5" style={{ color: "#840040" }} />
              Commentaires
              {item.Commentaire?.length > 0 && (
                <span
                  className="ml-2 text-xs font-medium px-2 py-0.5 rounded-full text-white"
                  style={{ backgroundColor: "#840040" }}
                >
                  {item.Commentaire.length}
                </span>
              )}
            </h3>

            {/* Liste des commentaires */}
            <div className="space-y-3 max-h-[150px] overflow-y-auto pr-1 mb-4">
              {item.Commentaire?.length > 0 ? (
                item.Commentaire.map((c, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-lg p-3"
                    style={{ border: "1px solid #84004030" }}
                  >
                    <div className="flex items-start gap-3">
                      {/* Avatar */}
                      <div
                        className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold text-white flex-shrink-0"
                        style={{ backgroundColor: "#840040" }}
                      >
                        {(c.nomComplet || "A")[0]}
                      </div>

                      <div className="flex-1">
                        <div className="flex items-baseline gap-2 mb-1">
                          <span className="font-semibold text-slate-800 text-sm">
                            {c.nomComplet || "Anonyme"}
                          </span>
                          {c.createdAt && (
                            <span
                              className="text-xs"
                              style={{ color: "#840040" }}
                            >
                              {new Date(c.createdAt).toLocaleString("fr-FR")}
                            </span>
                          )}
                        </div>
                        <p className="text-sm text-slate-700 leading-relaxed">
                          {c.commentaire}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-6" style={{ color: "#840040" }}>
                  <MessageSquare className="w-8 h-8 mx-auto mb-2 opacity-50" />
                  <p className="text-sm">Aucun commentaire pour le moment</p>
                </div>
              )}
            </div>

            {/* Ajout commentaire */}
            <div className="border-t pt-4" style={{ borderColor: "#84004040" }}>
              <textarea
                value={commentaireInput}
                onChange={(e) => setCommentaireInput(e.target.value)}
                placeholder="Ajouter un commentaire..."
                className="w-full min-h-[80px] text-sm rounded-lg p-3 focus:outline-none"
                style={{
                  border: "1px solid #84004040",
                }}
                onFocus={(e) =>
                  (e.target.style.boxShadow = "0 0 0 2px #84004040")
                }
                onBlur={(e) => (e.target.style.boxShadow = "none")}
              />

              <div className="flex justify-end mt-3">
                <button
                  onClick={handleAddComment}
                  disabled={isSendingComment}
                  className="text-white text-sm font-medium px-4 py-2 rounded-lg disabled:opacity-50"
                  style={{ backgroundColor: "#840040" }}
                >
                  {isSendingComment ? "⏳ Envoi en cours..." : "Envoyer"}
                </button>
              </div>
            </div>
          </div>

          <div className="bg-slate-50 rounded-lg border border-slate-200 p-6 mt-6">
            {/* Header */}
            <h3 className="text-base font-semibold text-slate-800 mb-4 flex items-center gap-2">
              <History className="w-5 h-5" style={{ color: "#840040" }} />
              Historiques
              {item.Historique?.length > 0 && (
                <span
                  className="ml-2 text-xs font-medium px-2 py-0.5 rounded-full text-white"
                  style={{ backgroundColor: "#840040" }}
                >
                  {item.Historique.length}
                </span>
              )}
            </h3>

            {/* Liste des historiques */}
            <div className="space-y-3 max-h-[150px] overflow-y-auto pr-1">
              {item.Historique?.length > 0 ? (
                item.Historique.map((h, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-lg p-3"
                    style={{ border: "1px solid #84004030" }}
                  >
                    <div className="flex items-start gap-3">
                      {/* Icône timeline */}
                      <div
                        className="w-8 h-8 rounded-full flex items-center justify-center text-white flex-shrink-0"
                        style={{ backgroundColor: "#840040" }}
                      >
                        <History className="w-4 h-4" />
                      </div>

                      <div className="flex-1">
                        <div className="flex items-baseline gap-2 mb-1">
                          <span className="font-semibold text-slate-800 text-sm">
                            {h.title || "Sans titre"}
                          </span>
                          {h.createdAt && (
                            <span
                              className="text-xs"
                              style={{ color: "#840040" }}
                            >
                              {new Date(h.createdAt).toLocaleString("fr-FR")}
                            </span>
                          )}
                        </div>

                        <p className="text-sm text-slate-700 leading-relaxed">
                          {h.description || "—"}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-6" style={{ color: "#840040" }}>
                  <History className="w-8 h-8 mx-auto mb-2 opacity-50" />
                  <p className="text-sm">Aucun historique disponible</p>
                </div>
              )}
            </div>
          </div>

          <br />
        </div>
      </div>
    </div>
  );
};

export default Radiation;
